import { AvailabilityStatus, TranslationLookups } from 'api/model';
import styled from 'styled-components';
import React from 'react';

const Badge = styled.div<{ background?: string }>`
  display: flex;
  flex-direction: row;
  /* align-items: center;
  justify-content: center; */
  width: 17px;
  height: 17px;
  border-radius: 2px;
  border-width: 0.5px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.foreground.primary};
  background-color: ${({ theme, background }) =>
    background || theme.colors.background.button};
  color: ${({ theme }) => theme.colors.foreground.button};
  /* text-align: center; */
  padding: 1px;
  /* font-size: 0.7em; */
`;

interface Props {
  availabilityStatus: AvailabilityStatus;
  availabilityStatuses: TranslationLookups['availabilityStatuses'];
  availabilityStatusColorCodes: TranslationLookups['availabilityStatusColorCodes'];
}

const AvailabilityStatusBadge: React.FC<Props> = ({
  availabilityStatus,
  availabilityStatuses,
  availabilityStatusColorCodes,
}) => {
  const title = availabilityStatuses[availabilityStatus] || undefined;

  return (
    <Badge
      background={availabilityStatusColorCodes[availabilityStatus]}
      title={title}
    />
  );
};

export default AvailabilityStatusBadge;
